export default {
    name: 'circle-progress',
    props: {
        progress:{
            type: Number,
            default: 50
        },
        status: {
            default: 'progress',
            validator: function (value) {
                return ['success', 'fail', 'progress'].includes(value)
            }
        }
    },
    data () {
        return {
            circumference: 2 * Math.PI * 54,
        }
    },
    computed: {
        dashoffset() {
            return this.circumference * (1 - this.progress / 100)
        },
    },
};


// WEBPACK FOOTER //
// ./src/components/circleProgress/circleProgress.js